import axios from 'axios';
import { constructServiceURL } from '../../../../../../utils/URLTools';

export const apiEditHandlers = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'editHandlerDefault',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      mrdName: payload.mrdName,
      handlerId: payload.handlerId,
    },
  });
  return axios.put(serviceURL, {
    newValidFrom: payload.newValidFrom,
    printReceipt: payload.printReceipt,
    validFrom: payload.validFrom,
    validTo: payload.validTo,
  });
};
